import { useState } from 'react';
import BooleanValue from '@components/booleanValue/BooleanValue';
import { VerifyButton } from '@routes/adminRoutes/sharedComponents/SharedStyledComponents';
import { adminVerifyUserEmailV2 } from '@utils/api';
import { useToast } from '@contexts/Toast.context';
import { useConfirm } from '@contexts/Confirm.context';

const EmailVerify = ({ cellValue, email }) => {
	const { addToast } = useToast();
	const { confirm } = useConfirm();
	const [verified, setVerified] = useState(cellValue);

	const handleVerify = async () => {
		const userConfirmed = await confirm({
			title: 'Verify Email',
			message: (
				<>
					Are you sure you want to verify <strong>{email}</strong>?
				</>
			),
		});

		if (userConfirmed) {
			try {
				// v2 returns { email_address, verified }; helper throws on failure.
				const response = await adminVerifyUserEmailV2(email);
				if (response?.verified) {
					setVerified(true);
					addToast({
						id: 'email-verify-success',
						bg: 'success',
						title: 'Email verification is successful.',
					});
				} else {
					addToast({
						id: 'email-verify-error',
						bg: 'danger',
						title: 'Failed to verify email.',
					});
				}
			} catch (err) {
				console.error('Failed to verify email', err);
				addToast({
					id: 'email-verify-error',
					bg: 'danger',
					title: 'Failed to verify email.',
				});
			}
		}
	};

	return (
		<>
			<BooleanValue value={verified} />

			{!verified && (
				<VerifyButton size="sm" onClick={handleVerify}>
					Verify
				</VerifyButton>
			)}
		</>
	);
};

export default EmailVerify;
